// Pure helpers used by the team_assist_message component. Lives in its own
// module so unit tests can exercise them without pulling in the React
// component tree (and its transitive imports — Slider, FontAwesome icons,
// etc., which require a DOM-ish environment).

// formatToolDisplayName renders a destructive external tool name as
// `<action> (<config>)`, where <action> is the substring after the last '-'
// and <config> is the substring before the first '-'. The MCP tool naming
// convention is `<configName>-<source>-<actionName>`, so this surfaces the
// agent-meaningful action name with the configuration that owns it in
// parentheses. Falls back to the raw name when it has no '-' or when either
// side would be empty.
export function formatToolDisplayName(toolName) {
  if (!toolName) {
    return '';
  }
  if (!toolName.includes('-')) {
    return toolName;
  }
  const lastDash = toolName.lastIndexOf('-');
  const firstDash = toolName.indexOf('-');
  const action = toolName.slice(lastDash + 1);
  const config = toolName.slice(0, firstDash);
  if (!action || !config) {
    return toolName;
  }
  return `${action} (${config})`;
}

// formatProposedActionArguments renders the LLM-emitted argument blob as
// pretty-printed JSON text. Always returns text — never HTML — so the
// caller can safely place it inside a <pre> without dangerouslySetInnerHTML.
// Accepts either a plain object or a JSON string (the wire format from
// supernova).
export function formatProposedActionArguments(args) {
  if (args == null) {
    return '';
  }
  if (typeof args === 'string') {
    if (!args.trim()) {
      return '';
    }
    try {
      return JSON.stringify(JSON.parse(args), null, 2);
    } catch (e) {
      return args;
    }
  }
  try {
    return JSON.stringify(args, null, 2);
  } catch (e) {
    return String(args);
  }
}
